import axios from "axios";
import { getAuthHeader, catchApi } from "../../utils";
import { cachedGet } from "../../utils/apiResponseCache";
import { apiGet, apiPost } from "../../api/client";

const VESSELS_CACHE_KEY = "options:vessels";
const VESSELS_TTL_MS = 60000;

export const v2_list_vessel_owners = async (page, limit, filter) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/owner/${page}/${limit}?filter=${encodeURIComponent(filter)}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_assign_vessel_group = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/group/assign`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_clone_vessel = async (vessel_id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/clone/${vessel_id}`;
    return axios.post(url, {}, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_save_vessel_owners = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/owner`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_toggleVesselOwnerStatus = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/owner`;
    return axios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_list_vessel = async (page, limit, filter) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessels/${page}/${limit}?filter=${encodeURIComponent(filter)}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_toggleVesselStatus = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel`;
    return axios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_vessel_detail = async (vessel_id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/details/${vessel_id}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_vessel_dashboard = async (vessel_id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/dashboard/${vessel_id}`;
    return catchApi(axios.get(url, getAuthHeader()).then((res) => res.data));
}

export const v2_list_vessel_groups = async (page, limit, filter) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/group/${page}/${limit}?filter=${encodeURIComponent(filter)}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_save_vessel_groups = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/group`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_toggleVesselGroupStatus = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/group`;
    return axios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_fetch_vesselOwners = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/options/vessel/owner`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_fetch_vessels = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/options/vessels`;
    return cachedGet(VESSELS_CACHE_KEY, () =>
        axios.get(url, getAuthHeader()).then((res) => res.data),
        VESSELS_TTL_MS
    );
}





export const v2_list_ship_types = async (page, limit, filter) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/shipType/${page}/${limit}?filter=${encodeURIComponent(filter)}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_save_ship_type = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/shipType`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_toggleShipTypeStatus = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/shipType`;
    return axios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v2_list_ship_purposes = async (page, limit, filter) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/shipPurpose/${page}/${limit}?filter=${encodeURIComponent(filter)}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_save_ship_purpose = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/shipPurpose`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_toggleShipPurposeStatus = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/shipPurpose`;
    return axios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_fetch_ship_type = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/options/shipType`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_fetch_group = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/options/vessel/group`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_fetch_ship_purpose = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/options/shipPurpose`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_save_vessel_data = async (section, model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/${section}`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_create_vessel_takeOver = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/vessel/take-over`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_fetch_vessel_wall_messages = async (vessel_id) =>
    apiGet(`/v2/vessel/wall/${vessel_id}/messages`);

export const v2_post_vessel_wall_message = async ({ vessel_id, body }) =>
    apiPost("/v2/vessel/wall/messages", { vessel_id, body });
